<template>
  <div class="page-outer">
    <div class="page-wrap">
      <div class="page flex-col">
        <div class="group_1 flex-col">
          <div class="block_1 flex-col">
            <div class="group_2 flex-row justify-between">
              <span class="text_1">产品介绍</span>
              <div class="box_1 flex-col"></div>
            </div>
            <span class="text_2">
              赛刻体育APP面向足篮球爱好者，提供即时比分数据，赛事详情数据，快速推送，积分榜，体育知识科普以及体育AI大模型服务。扎根海量体育数据土壤，为体育爱好者们提供专业、全面、及时的服务。
            </span>
            <span class="text_3">一、联赛全覆盖，比分更及时</span>
            <span class="text_4">
              覆盖全球足球、篮球等多项目赛事，从顶级联赛到地方赛事无一遗漏。依托多源采集与高速传输技术，比分及关键赛况实现毫秒级更新，让你同步掌握赛场动态。
            </span>
            <div class="text-group_1 flex-col justify-between">
              <span class="text_5">二、数据更详细，赛前赛中都提供</span>
              <span class="text_6">
                赛前提供两队历史交锋、伤病情况、球员战力等深度数据，助你预判局势。赛中实时更新控球率、射门数据、关键事件等多维统计，每一处赛场细节都清晰呈现。
              </span>
            </div>
            <div class="text-group_2 flex-col justify-between">
              <span class="text_7">三、专业体育知识，看球也科普</span>
              <span class="text_8">
                看球时同步解锁专业科普：解析&nbsp;4-3-3&nbsp;阵型的动态变化，科普&nbsp;“香蕉球”&nbsp;的马格努斯效应，解读&nbsp;VAR&nbsp;判罚依据，让你看懂战术玄机，告别看球只看个热闹。
              </span>
            </div>
            <div class="text-group_3 flex-col justify-between">
              <span class="text_9">四、体育AI大模型，想你所想</span>
              <span class="text_10">
                体育&nbsp;AI&nbsp;大模型懂你观赛所需：赛前分析教练决策，赛中解析战术玄机，实时生成球员热力图，还能答疑专业知识，精准匹配你的需求，让观赛与懂球无缝衔接。
              </span>
            </div>
            <span class="text_11">Product&nbsp;Introduction</span>
          </div>
          <div class="block_2 flex-row justify-between">
            <span class="text_12">团队介绍</span>
            <div class="group_3 flex-col"></div>
          </div>
          <div class="text-group_4 flex-col justify-between">
            <span class="text_13">
              我们的核心团队汇聚行业精英，成员均来自网易、360、百度、腾讯、字节等头部互联网企业，且多为拥有多年管理经验的核心骨干。
            </span>
            <span class="text_14">
              团队凭借对互联网产品逻辑的深刻理解与技术积淀，共同创立线上体育赛事分析服务公司。现广纳贤才，致力于打造深度、专业、便捷的移动应用服务，为用户带来优质的体育赛事分析体验。
            </span>
          </div>
          <div class="block_3 flex-row">
            <div class="text-group_5 flex-col justify-between">
              <span class="text_15">北京赛刻科技有限公司</span>
              <span class="paragraph_1">
                商务邮箱：zhanmeiche&#64;saikekeji.freeqiye.com
                
                官方微信：q1069551299
              </span>
            </div>
            <div class="text-group_6 flex-col justify-between">
              <a href="/userAgreement"><span class="text_16">用户协议</span></a>
              <a href="/privacy"><span class="text_17">隐私政策</span></a>
            </div>
            <div class="image-text_1 flex-row justify-between">
              <div>
                <img
                  class="image_1"
                  referrerpolicy="no-referrer"
                  src="./assets/img/SketchPnge6bacfe2bd22d1671b35fc207c63bad2464737f7a28f4238036c472be6677f6f.png"
                />
              </div>
              <span class="text-group_7">赛刻体育</span>
            </div>
          </div>
          <div class="block_4 flex-row">
            <div class="text-group_8 flex-col justify-between">
              <span class="text_18">Copyright&#64;2025北京悦体科技有限公司版权所有</span>
              <span class="text_19">京ICP备2025151211号-1</span>
            </div>
          </div>
          <span class="text_20">Team&nbsp;Introduction</span>
        </div>
        <div class="group_4 flex-col">
          <div class="block_5 flex-row justify-between">
            <div>
              <img
                class="image_2"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPnge6bacfe2bd22d1671b35fc207c63bad2464737f7a28f4238036c472be6677f6f.png"
              />
            </div>
            <span class="text_21">赛刻体育</span>
          </div>
          <div class="list_1 flex-row">
            <div
              class="image-wrapper_3 flex-col"
              :style="{ background: item.lanhuBg0 }"
              v-for="(item, index) in loopData0"
              :key="index"
            >
              <img
                v-if="item.slot1 === 1"
                class="image_3"
                referrerpolicy="no-referrer"
                :src="item.specialSlot1.lanhuimage0"
              />
            </div>
          </div>
          <div class="text-wrapper_1 flex-col"><span class="text_22">安卓下载</span></div>
          <div class="text-wrapper_2 flex-col"><span class="text_23">IOS下载</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bg0 from './assets/img/bg0.png'
import bg1 from './assets/img/bg1.png'
import bg2 from './assets/img/bg2.png'
import bg3 from './assets/img/bg3.png'
export default {
  data() {
    return {
      loopData0: [
        {
          llanhuBg0: 'rgba(216,216,216,1.000000)',
          specialSlot1: {
            lanhuimage0:
              bg0
          },
          slot1: 1
        },
        {
          lanhuBg0: 'rgba(216,216,216,1.000000)',
          specialSlot1: {
            lanhuimage0:
              bg1
          },
          slot1: 1
        },
        {
          lanhuBg0: 'rgba(216,216,216,1.000000)',
          specialSlot1: {
            lanhuimage0:
              bg2
          },
          slot1: 1
        },
        {
          lanhuBg0: 'rgba(216,216,216,1.000000)',
          specialSlot1: {
            lanhuimage0:
              bg3
          },
          slot1: 1
        }
      ],
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.response.css" />